import {
    Env
} from './env.js';
import {
    Urlparam
} from './urlparam.js'; // URLパラメータ
import {
    PageAncher
} from './page-ancher.js'; //ページ内アンカーリンク（スムーズスクロール）
import {
    ScrChecker
} from './scroll-checker-simple.js';
import {
    LazyLoad
} from './lazyload.js';

import Player from '@vimeo/player';
//https://www.npmjs.com/package/@vimeo/player

export class Opening {
    constructor() {
        this.body = {};
        this.html = {};
        this.env = {};
        this.paramAncher = {};
        this.openingMode = '';
        this.pageAncher = {};
        this.scrChecker = {};

        this.player = {};
        this.initMovFlg = false;
        this.initMovLoopedFlg = false; //雲のループのみの動画を読み込み(opなしなど)
        this.overMovLoopEnd = false; //動画ループ時点を超過(OP付き動画の場合、ループさせる時間をすぎているか

        this.vimeoPcId = "https://vimeo.com/655192429?quality=1080p"; //PC OP + Loop
        this.vimeoSpId = "https://vimeo.com/657259079?quality=1080p"; //SP OP + Loop

        this.vimeoPcIdLoop = "https://vimeo.com/655192153?quality=1080p"; //PC Loop
        this.vimeoSpIdLoop = "https://vimeo.com/657259026?quality=1080p"; //SP Loop

        this.vimeoNowID = ""; //現在再生中のVimeo ID
        this.currentPos = 0;

    }


    getMovId() {
        this.windowWidth = document.documentElement.clientWidth;
        this.windowHeight = document.documentElement.clientHeight; //iOS15でツールバーなどの影響があるかも
        //this.windowInnerWidth = window.innerWidth; //ツールバーを除く
        //this.windowInnerHeight = window.innerHeight; //ツールバーを除く

        console.log('clientWidth/Height: ', this.windowWidth, this.windowHeight);
        console.log('innerHeight: ', window.innerHeight);

        //画面の縦横比をチェック、再生する動画のIDを返す
        let returnStr = "";
        let coverVimeoId;

        if (document.getElementById('index-bg')) {
            let fullElem = document.getElementById('index-bg');
            fullElem.classList.remove('horisontal');
            fullElem.classList.remove('horisontal-wide');
            fullElem.classList.remove('vertical');
            fullElem.classList.remove('vertical-wide');
            fullElem.classList.remove('vertical-higher'); //iphoneXなど高さあり

            let logoElem = document.querySelectorAll('.index-cover__inner')[0];
            logoElem.classList.remove('horisontal');
            logoElem.classList.remove('vertical');

            let ratio = this.windowWidth / this.windowHeight;

            //bg
            // if (ratio >= (2560 / 1440)) { //2560 / 1440 = 1.777 より横長(だと数値が大きく)
            //     fullElem.classList.add('horisontal');
            //     returnStr = 'horisontal';
            // } else if (ratio >= (768 / 1024)) { //768 / 1024 = 0.75
            //     fullElem.classList.add('vertical-wide');
            //     returnStr = 'vertical-wide'
            // } else {
            //     fullElem.classList.add('vertical');
            //     returnStr = 'vertical';
            //     //console.log(this.windowHeight);
            //     if (ratio < (390 / 660)) { //iphoneXなど高さあり//ツールバーを除いて625px以上..より比率が良いか
            //         fullElem.classList.add('vertical-higher');
            //     }
            // }

            //bg
            if (ratio < 0.6) { //スマートフォン高さあり iphoneXなど 横縦比9:19.5 などを含む
                fullElem.classList.add('vertical-higher');
                fullElem.classList.add('vertical');
                returnStr = 'vertical';
            } else if (ratio < (768 / 1024)) { //スマートフォン一般、横縦比9:16などを含む
                fullElem.classList.add('vertical');
                returnStr = 'vertical';
            } else if (ratio <= 1) { //タブレットなど 横縦比3:5から3:4などを含む
                fullElem.classList.add('vertical-wide');
                returnStr = 'vertical-wide';
            } else if (ratio < (2560 / 1440)) { //PC 正方形よりは横長
                fullElem.classList.add('horisontal');
                returnStr = 'horisontal';
            } else { //PC 幅あり
                fullElem.classList.add('horisontal');
                fullElem.classList.add('horisontal-wide');
                returnStr = 'horisontal';
            }
            console.log('ratio=' + ratio);



            //logo
            if (ratio > 1) {
                logoElem.classList.add('horisontal');
            } else {
                logoElem.classList.add('vertical');
            }
        }

        if (returnStr == 'horisontal') {
            if (this.initMovLoopedFlg) {
                coverVimeoId = this.vimeoPcIdLoop;
            } else {
                if (this.openingMode == 'skip') {
                    coverVimeoId = this.vimeoPcIdLoop;
                } else {
                    coverVimeoId = this.vimeoPcId;
                }
            }
        } else {
            if (this.initMovLoopedFlg) {
                coverVimeoId = this.vimeoSpIdLoop;
            } else {
                if (this.openingMode == 'skip') {
                    coverVimeoId = this.vimeoSpIdLoop;
                } else {
                    coverVimeoId = this.vimeoSpId;
                }
            }
        }
        console.log("detect: Now VimeoId " + coverVimeoId + ", ratio = " + returnStr);
        return coverVimeoId;
    }


    onResize(mode) {
        let nextVimeoId = this.getMovId();
        let movSizeChangeFlg = false; //mov切り替えするか
        if (nextVimeoId == this.vimeoPcId || nextVimeoId == this.vimeoPcIdLoop) {
            //次はPCサイズ
            if (this.vimeoNowID == this.vimeoPcId || this.vimeoNowID == this.vimeoPcIdLoop) {
                //元もPCサイズ
            } else {
                //元がSPサイズ
                movSizeChangeFlg = true;
            }
        } else {
            //次はSPサイズ
            if (this.vimeoNowID == this.vimeoSpId || this.vimeoNowID == this.vimeoSpIdLoop) {
                //元もSPサイズ
            } else {
                //元がPCサイズ
                movSizeChangeFlg = true;
            }
        }

        if (mode == 'prepare') {
            // ウインドウサイズ変更で切り替えが必要な場合 準備
            if (movSizeChangeFlg) {
                if (document.getElementById('video')) {
                    document.getElementById('video').classList.add('hide'); //一旦隠す
                }
            }
        } else {
            // ウインドウサイズ変更で切り替えが必要な場合 実行
            if (movSizeChangeFlg) {
                console.log('ウインドウサイズ変更でmov切り替え');
                this.player.loadVideo(nextVimeoId).then(function (id) {
                    this.player.play();
                }).catch(function (error) {
                    //console.log(error);
                });
            } else {
                console.log('ウインドウサイズ変更だがmovそのまま');
            }
            this.vimeoNowID = nextVimeoId;
            setTimeout(() => {
                document.getElementById('video').classList.remove('hide');
            }, 700);
        }

    }

    onActive() {
        //console.log('tab active');
        this.player.play();
    }

    onDeActive() {
        //console.log('tab deActive');
        this.player.pause();
    }

    pauseLoop() {
        if (this.initMovLoopedFlg) {
            this.player.pause();
        }
    }
    restartLoop() {
        if (this.initMovLoopedFlg) {
            this.player.play();
        }
    }

    initMov() {
        let nextVimeoId = this.getMovId();
        let options = {
            id: nextVimeoId,
            width: 640,
            loop: true, //false,
            autoplay: true,
            muted: true,
            controls: false,
            background: 1,
            quality: '1080p'
        };

        //切り替え時間 PC
        let showContentTime = 3.6;
        let loopStartTime = 9.28;
        let loopEndTime = 54.0; //動画の最後2秒程度余裕がないと再生完了する

        //切り替え時間 SP
        if (nextVimeoId == this.vimeoSpId) {
            console.log('動画終了前にOP前へループさせる');
            showContentTime = 3.6;
            loopStartTime = 10.47;
            loopEndTime = 55.1; //動画の最後2秒程度余裕がないと再生完了する
        }

        this.player = new Player('video', options);
        this.player.on('play', () => {});
        this.player.ready().then(() => {
            if (this.openingMode == 'skip') {
                setTimeout(() => {
                    this.body.classList.add('opening-skipped');
                    this.body.classList.add('opening-finished');
                }, 600);
            }
            this.player.play();
        });
        this.player.on('timeupdate', (getAll) => {
            this.currentPos = getAll.seconds;

            let movName = "";
            if (this.vimeoNowID == this.vimeoPcId) {
                movName = "PC / OP + CloudLoop";
            }
            if (this.vimeoNowID == this.vimeoSpId) {
                movName = "SP / OP + CloudLoop";
            }
            if (this.vimeoNowID == this.vimeoPcIdLoop) {
                movName = "PC / CloudLoop";
            }
            if (this.vimeoNowID == this.vimeoSpIdLoop) {
                movName = "SP / CloudLoop";
            }
            //console.log(this.currentPos, movName);

            //opあり
            if (this.currentPos >= showContentTime && !this.initMovLoopedFlg) {
                this.body.classList.add('opening-finished');
                this.initMovLoopedFlg = true;
                this.showMainContent();
            }

            if (this.currentPos >= loopEndTime) {
                //ループする時間をすぎていないか
                this.overMovLoopEnd = true;
            }

            //再生中動画がOPを含む動画の場合は、JSでOP後へ戻して雲がループに見えるように
            if (this.vimeoNowID == this.vimeoPcId || this.vimeoNowID == this.vimeoSpId || this.overMovLoopEnd) {
                if (this.currentPos >= loopEndTime) {
                    this.player.pause();
                    this.player.setCurrentTime(loopStartTime);
                    this.overMovLoopEnd = false;
                    this.player.play();
                }
            }



        });
        this.vimeoNowID = nextVimeoId;
    }


    init() {
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];

        // 環境
        this.env = new Env();
        this.env.detectEnv();

        // URLパラメータ
        this.paramAncher = new Urlparam();
        this.paramAncher.getParam('op', location.href);

        if (document.getElementById('index-bg')) {
            if (this.env.browser.ie11 || this.paramAncher.param == 0) {
                // IE11か?op=0 なら Openingなし
                this.skipOpening();
            } else {
                this.flg = true;
                this.startOpening();
            }
        }
    }

    skipOpening() {
        console.log('Opening skip');

        // 動画を再生
        if (document.getElementById('video')) {
            if (!this.initMovFlg) {
                this.openingMode = 'skip';
                this.initMov();
                this.initMovFlg = true;
                this.initMovLoopedFlg = true;
            }
            this.showMainContent();
        }


    }

    startOpening() {
        if (document.getElementById('index-bg')) {
            console.log('Opening start');

            // 動画を再生
            if (document.getElementById('video')) {
                if (!this.initMovFlg) {
                    this.openingMode = 'start';
                    this.initMov();
                    this.initMovFlg = true;
                }
            }
        }
    }

    showMainContent() {
        let template;
        let clone;
        // HomeのOP以下のコンテンツ
        if (document.getElementById('index-content-template')) {
            template = document.getElementById('index-content-template');
            clone = template.content.cloneNode(true);
            document.getElementById('js-index-content-container').appendChild(clone);
        }

        // スクロールチェッカー
        this.scrChecker = new ScrChecker();
        this.scrChecker.init();

        //page ancher - OP/ajax要素などある場合はOP後に
        //smoothscroll.polyfill();
        this.pageAncher = new PageAncher();
        this.pageAncher.init();


        // lazy load : PC Safari 対策
        let lazyload = new LazyLoad();
        lazyload.init();


        //Contact form 7 要素がAjaxで読み込みの場合
        this.initCf7();

        let selectElems = document.querySelectorAll('.wpcf7-select');
        [].forEach.call(selectElems, (elem) => {
            elem.addEventListener('change', () => {
                let idx = elem.selectedIndex;
                //let value = elem.options[idx].value;
                //let text  = elem.options[idx].text;
                if (idx != 0) {
                    elem.classList.add('option-selected');
                } else {
                    elem.classList.remove('option-selected');
                }

            });
        });
    }


    //Contact form 7 
    initCf7() {
        // Contact Form 7のフォームのイベントを再登録
        if (typeof wpcf7.init === 'function') {
            document.querySelectorAll('.wpcf7 > form').forEach(function (form) {
                wpcf7.init(form);
            });
        }
        // ページデータ読みのノード書き換えの際に登録するイベントを記載
    };


    scrChecker_onUpdate() {
        if (this.initMovLoopedFlg) {
            this.scrChecker.onUpdate();
        }
        //this.player.play();
    }
}